export const Subscription = {
  getSubscriber: (email: string) => `Customer/Newsletter/${email}`,
  updateSubscriber: () => 'Customer/Newsletter',
  addSubscriber: () => 'Customer/Newsletter',
};
